<template>
  <div class="affiliates">

    <div class="title-button">

      <h1>Affiliates</h1>

      <router-link to="/affiliates/create" class="button p-3" v-if="userRole == 1">New affiliate</router-link>

    </div>

    <div class="box">

      <form @submit.stop.prevent="doSearch" class="box__header form--inline">
        <input v-model="quickSearch" type="search" placeholder="Quick search">
        <button class="button button--small" type="submit">Search</button>
      </form>

      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="options"
        @edit="doAlertEdit"
        @delete="doAlertDelete"
        >
        <template v-slot:active="{ row }">
          <td v-if="userRole == 1">
            <label class="switch">
              <input class="toggle-switch" :id="row.id" type="checkbox" checked v-if="row.is_active">
              <input class="toggle-switch" :id="row.id" type="checkbox" v-else>
              <span class="switch__slider"></span>
            </label>
          </td>
          <td v-else>--</td>
        </template>
      </vdtnet-table>

    </div><!-- box -->

  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'

export default {
  name: 'affiliates',
  components: {
    VdtnetTable
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data() {
    return {
      options: {
        ajax: {
          url: this.$api + 'affiliates/table',
          headers: {
            'Accept': 'application/json',
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
      },
      fields: {
        code: { label: 'Code'},
        name: { label: 'Name'},
        active: { sortable: false, label: 'Status', className: 'table-action' },
        edit: {
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            return `<a href="/affiliates/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        },
        delete: {
          sortable: false,
          label: ' ',
          className: 'table-action',
          render: (data, type, row) => {
            if (this.userRole == 1) {
              return `<a href="/affiliates/delete/${ row.id }" data-action="delete" class="icon icon--delete">Delete</a>`
            } else {
              return ''
            }
          }
        }
      },
      quickSearch: ''
    }
  },
  mounted() {
    // Add the event handler on component mount
    window.$(document).on('change', '.toggle-switch', this.changeAffiliateStatus)
  },
  beforeDestroy() {
    // Remove the event handler before the component is destroyed
    window.$(document).off('change', '.toggle-switch')
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    doAlertEdit(data) {
      this.$router.push({ name: 'affiliate-edit', params: { id: data.id }})
    },
    doAlertDelete(data) {
      this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'affiliates/' + data.id + '/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.errors = response.errors
        if(response.success == true) {
          this.$refs.table.reload()
          this.$notify({
            type: 'success',
            title: response.message
          });
        } else if (response.errors) {
          this.$notify({
            type: 'error',
            title: response.message
          });
        } else {
          this.$notify({
            type: 'error',
            title: response.Error
          });
        }
        this.$store.dispatch('setLoadStatus')
      });
    },
    changeAffiliateStatus(event) {
     this.$store.dispatch('setLoadStatus')
      fetch(this.$api + 'affiliates/' + event.target.id, {
        method: 'POST',
        body: JSON.stringify({
          'is_active': event.target.checked
        }),
        headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$notify({
          type: 'success',
          title: response.message
        });
        this.$store.dispatch('setLoadStatus')
      })
      .catch(error => {
        console.log(error)
        this.$store.dispatch('setLoadStatus')
      })
    }
  }
}
</script>
